module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "upgrade-plan-wrapper"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "icon-wrapper"
  }, [_c('i', {
    staticClass: "icon yule-icon-lock"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('errors.plans.not_allowed_modal.title')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('errors.plans.not_allowed_modal.description')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('button', {
    staticClass: "btn btn-flat added-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.navigateSalesPage
    }
  }, [_vm._v(_vm._s(_vm.$t('errors.plans.not_allowed_modal.button')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea397b4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Specific/PermissionNotAllowedModal.vue
// module id = 2008
// module chunks = 0